
<script setup>
import { ref, watch } from 'vue';
import { useDocumentVisibility } from '@vueuse/core';

defineProps({
    debug:{
        type: Boolean,
        default: false
    }
})

const emits = defineEmits(['timeAway']);

const visibility = useDocumentVisibility();
const awayStartTime = ref(null);

watch(visibility, (current, previous) => {
    if (current === 'visible' && previous === 'hidden') {
        const timeAway = Date.now() - awayStartTime.value;
        awayStartTime.value = null;
        emits('timeAway', timeAway);
    }
    if(current === 'hidden' && previous === 'visible') {
        awayStartTime.value = Date.now();
    }
})
</script>
<template>
    <div>

    </div>
</template>
